import type { NBranches } from '@app/types/Branches';

import type { ItemProps } from '@pages/Branches/BranchesList/data/StatusOptions';

export const getSelectorOptions = (
  props: NBranches.GetSelectorOptionsProps
) => {
  const { flag, defaultData, setOptions, setData, form, editableChainId } =
    props;

  const options: ItemProps[] = [];

  if (flag === 'chains') {
    options.push({
      label: 'Без сети',
      value: '0',
    });
  }

  if (flag === 'cities') {
    defaultData.forEach((item: string) => {
      if (item) {
        options.push({
          label: item,
          value: item,
        });
      }
    });
  } else {
    defaultData.forEach((item: { Name: string; Id: number }) => {
      if (item) {
        options.push({
          label: item.Name,
          value: String(item.Id),
        });
      }
    });
  }

  let data;

  if (flag === 'cities') {
    data = defaultData;
  } else {
    data = defaultData.map(({ Id }) => String(Id));
  }

  if (flag === 'chains') {
    data.push('0');
  }

  setOptions(options);

  if (setData) {
    setData(data);
  }

  if (form) {
    if (flag === 'chains' && editableChainId) {
      return form.setFieldValue(flag, [String(editableChainId)]);
    }
    form.setFieldValue(flag, data);
  }
};
